// TODO [WLEF-478] Find another way to preprocess data
export const preprocessData = (fieldValues: Record<string, any>) =>
    Object.keys(fieldValues).reduce((acc: Record<string, any>, fieldName: string) => {
        if (typeof fieldValues[fieldName] === 'string') {
            const lastChar = fieldValues[fieldName][fieldValues[fieldName].length - 1];
            if (lastChar === '+') {
                const digitsOnly = `${fieldValues[fieldName]}`.match(/[0-9.]+/g);
                acc[fieldName] = digitsOnly ? parseFloat(digitsOnly?.[0]) : fieldValues[fieldName];
            } else {
                acc[fieldName] = fieldValues[fieldName] === '' ? undefined : fieldValues[fieldName];
            }
        } else {
            acc[fieldName] = fieldValues[fieldName];
        }
        return acc;
    }, {});
